import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Final Wishes checklist screen
import FinalWishesChecklistScreen from '../../screens/checklists/FinalWishesChecklistScreen';

// Body Arrangements screens
import BodyArrangementsIntroScreen from '../../screens/tasks/wishes/bodyArrangements/BodyArrangementsIntroScreen';
import BodyArrangementsInputScreen from '../../screens/tasks/wishes/bodyArrangements/BodyArrangementsInputScreen';
import BodyArrangementsDataScreen from '../../screens/tasks/wishes/bodyArrangements/BodyArrangementsDataScreen';
import BodyArrangementsLockUnlockScreen from '../../screens/tasks/wishes/bodyArrangements/BodyArrangementsLockUnlockScreen';
import BodyArrangementsLockedScreen from '../../screens/tasks/wishes/bodyArrangements/BodyArrangementsLockedScreen';
import BodyArrangementsUnlockedScreen from '../../screens/tasks/wishes/bodyArrangements/BodyArrangementsUnlockedScreen';

// Burial Plot screens
import BurialPlotIntroScreen from '../../screens/tasks/wishes/burialPlot/BurialPlotIntroScreen';
import BurialPlotInputScreen from '../../screens/tasks/wishes/burialPlot/BurialPlotInputScreen';
import BurialPlotDataScreen from '../../screens/tasks/wishes/burialPlot/BurialPlotDataScreen';
import BurialPlotLockUnlockScreen from '../../screens/tasks/wishes/burialPlot/BurialPlotLockUnlockScreen';
import BurialPlotLockedScreen from '../../screens/tasks/wishes/burialPlot/BurialPlotLockedScreen';
import BurialPlotUnlockedScreen from '../../screens/tasks/wishes/burialPlot/BurialPlotUnlockedScreen';

// Casket/Urn screens
import CasketUrnIntroScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnIntroScreen';
import CasketUrnInputScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnInputScreen';
import CasketUrnInputCasketScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnInputCasketScreen';
import CasketUrnInputUrnScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnInputUrnScreen';
import CasketUrnInputOtherScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnInputOtherScreen';
import CasketUrnDataScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnDataScreen';
import CasketUrnLockUnlockScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnLockUnlockScreen';
import CasketUrnLockedScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnLockedScreen';
import CasketUrnUnlockedScreen from '../../screens/tasks/wishes/casketUrn/CasketUrnUnlockedScreen';

// Funeral Home screens
import FuneralHomeIntroScreen from '../../screens/tasks/wishes/funeralHome/FuneralHomeIntroScreen';
import FuneralHomeInputScreen from '../../screens/tasks/wishes/funeralHome/FuneralHomeInputScreen';
import FuneralHomeDataScreen from '../../screens/tasks/wishes/funeralHome/FuneralHomeDataScreen';
import FuneralHomeLockUnlockScreen from '../../screens/tasks/wishes/funeralHome/FuneralHomeLockUnlockScreen';
import FuneralHomeLockedScreen from '../../screens/tasks/wishes/funeralHome/FuneralHomeLockedScreen';
import FuneralHomeUnlockedScreen from '../../screens/tasks/wishes/funeralHome/FuneralHomeUnlockedScreen';

// Funeral Instructions screens
import FuneralInstructionsIntroScreen from '../../screens/tasks/wishes/funeralInstructions/FuneralInstructionsIntroScreen';
import FuneralInstructionsInputScreen from '../../screens/tasks/wishes/funeralInstructions/FuneralInstructionsInputScreen';
import FuneralInstructionsDataScreen from '../../screens/tasks/wishes/funeralInstructions/FuneralInstructionsDataScreen';
import FuneralInstructionsLockUnlockScreen from '../../screens/tasks/wishes/funeralInstructions/FuneralInstructionsLockUnlockScreen';
import FuneralInstructionsLockedScreen from '../../screens/tasks/wishes/funeralInstructions/FuneralInstructionsLockedScreen';
import FuneralInstructionsUnlockedScreen from '../../screens/tasks/wishes/funeralInstructions/FuneralInstructionsUnlockedScreen';

// Memorial Service screens
import MemorialServiceIntroScreen from '../../screens/tasks/wishes/memorialService/MemorialServiceIntroScreen';
import MemorialServiceInputScreen from '../../screens/tasks/wishes/memorialService/MemorialServiceInputScreen';
import MemorialServiceDataScreen from '../../screens/tasks/wishes/memorialService/MemorialServiceDataScreen';
import MemorialServiceLockUnlockScreen from '../../screens/tasks/wishes/memorialService/MemorialServiceLockUnlockScreen';
import MemorialServiceLockedScreen from '../../screens/tasks/wishes/memorialService/MemorialServiceLockedScreen';
import MemorialServiceUnlockedScreen from '../../screens/tasks/wishes/memorialService/MemorialServiceUnlockedScreen';

// Letter To Loved Ones screens
import LetterToLovedOnesIntroScreen from '../../screens/tasks/wishes/letterToLovedOnes/LetterToLovedOnesIntroScreen';
import LetterToLovedOnesInputScreen from '../../screens/tasks/wishes/letterToLovedOnes/LetterToLovedOnesInputScreen';
import LetterToLovedOnesDataScreen from '../../screens/tasks/wishes/letterToLovedOnes/LetterToLovedOnesDataScreen';
import LetterToLovedOnesLockUnlockScreen from '../../screens/tasks/wishes/letterToLovedOnes/LetterToLovedOnesLockUnlockScreen';
import LetterToLovedOnesLockedScreen from '../../screens/tasks/wishes/letterToLovedOnes/LetterToLovedOnesLockedScreen';
import LetterToLovedOnesUnlockedScreen from '../../screens/tasks/wishes/letterToLovedOnes/LetterToLovedOnesUnlockedScreen';

// Officiant screens
import OfficiantIntroScreen from '../../screens/tasks/wishes/officiant/OfficiantIntroScreen';
import OfficiantInputScreen from '../../screens/tasks/wishes/officiant/OfficiantInputScreen';
import OfficiantDataScreen from '../../screens/tasks/wishes/officiant/OfficiantDataScreen';
import OfficiantLockUnlockScreen from '../../screens/tasks/wishes/officiant/OfficiantLockUnlockScreen';
import OfficiantLockedScreen from '../../screens/tasks/wishes/officiant/OfficiantLockedScreen';
import OfficiantUnlockedScreen from '../../screens/tasks/wishes/officiant/OfficiantUnlockedScreen';

// Prayers and Readings screens
import PrayersReadingsIntroScreen from '../../screens/tasks/wishes/prayersReadings/PrayersReadingsIntroScreen';
import PrayersReadingsInputScreen from '../../screens/tasks/wishes/prayersReadings/PrayersReadingsInputScreen';
import PrayersReadingsDataScreen from '../../screens/tasks/wishes/prayersReadings/PrayersReadingsDataScreen';
import PrayersReadingsLockUnlockScreen from '../../screens/tasks/wishes/prayersReadings/PrayersReadingsLockUnlockScreen';
import PrayersReadingsLockedScreen from '../../screens/tasks/wishes/prayersReadings/PrayersReadingsLockedScreen';
import PrayersReadingsUnlockedScreen from '../../screens/tasks/wishes/prayersReadings/PrayersReadingsUnlockedScreen';

// Tribute Donations screens
import TributeDonationsIntroScreen from '../../screens/tasks/wishes/tributeDonations/TributeDonationsIntroScreen';
import TributeDonationsInputScreen from '../../screens/tasks/wishes/tributeDonations/TributeDonationsInputScreen';
import TributeDonationsDataScreen from '../../screens/tasks/wishes/tributeDonations/TributeDonationsDataScreen';
import TributeDonationsLockUnlockScreen from '../../screens/tasks/wishes/tributeDonations/TributeDonationsLockUnlockScreen';
import TributeDonationsLockedScreen from '../../screens/tasks/wishes/tributeDonations/TributeDonationsLockedScreen';
import TributeDonationsUnlockedScreen from '../../screens/tasks/wishes/tributeDonations/TributeDonationsUnlockedScreen';

// Food Preferences screens
import FoodPreferencesIntroScreen from '../../screens/tasks/wishes/foodPreferences/FoodPreferencesIntroScreen';
import FoodPreferencesInputScreen from '../../screens/tasks/wishes/foodPreferences/FoodPreferencesInputScreen';
import FoodPreferencesDataScreen from '../../screens/tasks/wishes/foodPreferences/FoodPreferencesDataScreen';
import FoodPreferencesLockUnlockScreen from '../../screens/tasks/wishes/foodPreferences/FoodPreferencesLockUnlockScreen';
import FoodPreferencesLockedScreen from '../../screens/tasks/wishes/foodPreferences/FoodPreferencesLockedScreen';
import FoodPreferencesUnlockedScreen from '../../screens/tasks/wishes/foodPreferences/FoodPreferencesUnlockedScreen';

// Music screens
import MusicIntroScreen from '../../screens/tasks/wishes/music/MusicIntroScreen';
import MusicInputScreen from '../../screens/tasks/wishes/music/MusicInputScreen';
import MusicDataScreen from '../../screens/tasks/wishes/music/MusicDataScreen';
import MusicLockUnlockScreen from '../../screens/tasks/wishes/music/MusicLockUnlockScreen';
import MusicLockedScreen from '../../screens/tasks/wishes/music/MusicLockedScreen';
import MusicUnlockedScreen from '../../screens/tasks/wishes/music/MusicUnlockedScreen';

// PallBearer screens
import PallBearerIntroScreen from '../../screens/tasks/wishes/pallbearers/PallBearerIntroScreen';
import PallBearerInputScreen from '../../screens/tasks/wishes/pallbearers/PallBearerInputScreen';
import PallBearerDataScreen from '../../screens/tasks/wishes/pallbearers/PallBearerDataScreen';
import PallBearerLockUnlockScreen from '../../screens/tasks/wishes/pallbearers/PallBearerLockUnlockScreen';
import PallBearerLockedScreen from '../../screens/tasks/wishes/pallbearers/PallBearerLockedScreen';
import PallBearerUnlockedScreen from '../../screens/tasks/wishes/pallbearers/PallBearerUnlockedScreen';

// TraditionsRituals screens
import TraditionsRitualsIntroScreen from '../../screens/tasks/wishes/traditionsRituals/TraditionsRitualsIntroScreen';
import TraditionsRitualsInputScreen from '../../screens/tasks/wishes/traditionsRituals/TraditionsRitualsInputScreen';
import TraditionsRitualsDataScreen from '../../screens/tasks/wishes/traditionsRituals/TraditionsRitualsDataScreen';
import TraditionsRitualsLockUnlockScreen from '../../screens/tasks/wishes/traditionsRituals/TraditionsRitualsLockUnlockScreen';
import TraditionsRitualsLockedScreen from '../../screens/tasks/wishes/traditionsRituals/TraditionsRitualsLockedScreen';
import TraditionsRitualsUnlockedScreen from '../../screens/tasks/wishes/traditionsRituals/TraditionsRitualsUnlockedScreen';

// WakeDetails screens
import WakeDetailsIntroScreen from '../../screens/tasks/wishes/wakeDetails/WakeDetailsIntroScreen';
import WakeDetailsInputScreen from '../../screens/tasks/wishes/wakeDetails/WakeDetailsInputScreen';
import WakeDetailsDataScreen from '../../screens/tasks/wishes/wakeDetails/WakeDetailsDataScreen';
import WakeDetailsLockUnlockScreen from '../../screens/tasks/wishes/wakeDetails/WakeDetailsLockUnlockScreen';
import WakeDetailsLockedScreen from '../../screens/tasks/wishes/wakeDetails/WakeDetailsLockedScreen';
import WakeDetailsUnlockedScreen from '../../screens/tasks/wishes/wakeDetails/WakeDetailsUnlockedScreen';

// Eulogy screens
import EulogyIntroScreen from '../../screens/tasks/wishes/eulogy/EulogyIntroScreen';
import EulogyIntro2Screen from '../../screens/tasks/wishes/eulogy/EulogyIntro2Screen';
import EulogyInputScreen from '../../screens/tasks/wishes/eulogy/EulogyInputScreen';
import EulogyWriterInputScreen from '../../screens/tasks/wishes/eulogy/EulogyWriterInputScreen';
import EulogyDataScreen from '../../screens/tasks/wishes/eulogy/EulogyDataScreen';
import { EulogyLockUnlockScreen } from '../../screens/tasks/wishes/eulogy/EulogyLockUnlockScreen';
import EulogyLockedScreen from '../../screens/tasks/wishes/eulogy/EulogyLockedScreen';
import { EulogyUnlockedScreen } from '../../screens/tasks/wishes/eulogy/EulogyUnlockedScreen';

// HeadstoneDetails screens
import HeadstoneDetailsIntroScreen from '../../screens/tasks/wishes/headstoneDetails/HeadstoneDetailsIntroScreen';
import HeadstoneDetailsInputScreen from '../../screens/tasks/wishes/headstoneDetails/HeadstoneDetailsInputScreen';
import HeadstoneDetailsDataScreen from '../../screens/tasks/wishes/headstoneDetails/HeadstoneDetailsDataScreen';
import HeadstoneDetailsLockUnlockScreen from '../../screens/tasks/wishes/headstoneDetails/HeadstoneDetailsLockUnlockScreen';
import HeadstoneDetailsLockedScreen from '../../screens/tasks/wishes/headstoneDetails/HeadstoneDetailsLockedScreen';
import HeadstoneDetailsUnlockedScreen from '../../screens/tasks/wishes/headstoneDetails/HeadstoneDetailsUnlockedScreen';

// ObituaryDetails screens
import ObituaryDetailsIntroScreen from '../../screens/tasks/wishes/obituaryDetails/ObituaryDetailsIntroScreen';
import ObituaryDetailsInputScreen from '../../screens/tasks/wishes/obituaryDetails/ObituaryDetailsInputScreen';
import ObituaryDetailsWriterInputScreen from '../../screens/tasks/wishes/obituaryDetails/ObituaryDetailsWriterInputScreen';
import ObituaryDetailsDataScreen from '../../screens/tasks/wishes/obituaryDetails/ObituaryDetailsDataScreen';
import ObituaryDetailsLockUnlockScreen from '../../screens/tasks/wishes/obituaryDetails/ObituaryDetailsLockUnlockScreen';
import ObituaryDetailsLockedScreen from '../../screens/tasks/wishes/obituaryDetails/ObituaryDetailsLockedScreen';
import ObituaryDetailsUnlockedScreen from '../../screens/tasks/wishes/obituaryDetails/ObituaryDetailsUnlockedScreen';

const Stack = createNativeStackNavigator();

const WishesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Main Final Wishes Checklist */}
      <Stack.Screen name="FinalWishesChecklist" component={FinalWishesChecklistScreen} />
      
      {/* Body Arrangements Screens */}
      <Stack.Screen name="BodyArrangementsIntro" component={BodyArrangementsIntroScreen} />
      <Stack.Screen name="BodyArrangementsInput" component={BodyArrangementsInputScreen} />
      <Stack.Screen name="BodyArrangementsData" component={BodyArrangementsDataScreen} />
      <Stack.Screen name="BodyArrangementsLockUnlock" component={BodyArrangementsLockUnlockScreen} />
      <Stack.Screen name="BodyArrangementsLocked" component={BodyArrangementsLockedScreen} />
      <Stack.Screen name="BodyArrangementsUnlocked" component={BodyArrangementsUnlockedScreen} />
      
      {/* Burial Plot Screens */}
      <Stack.Screen name="BurialPlotIntro" component={BurialPlotIntroScreen} />
      <Stack.Screen name="BurialPlotInput" component={BurialPlotInputScreen} />
      <Stack.Screen name="BurialPlotData" component={BurialPlotDataScreen} />
      <Stack.Screen name="BurialPlotLockUnlock" component={BurialPlotLockUnlockScreen} />
      <Stack.Screen name="BurialPlotLocked" component={BurialPlotLockedScreen} />
      <Stack.Screen name="BurialPlotUnlocked" component={BurialPlotUnlockedScreen} />
      
      {/* Casket/Urn Screens */}
      <Stack.Screen name="CasketUrnIntro" component={CasketUrnIntroScreen} />
      <Stack.Screen name="CasketUrnInput" component={CasketUrnInputScreen} />
      <Stack.Screen name="CasketUrnInputCasket" component={CasketUrnInputCasketScreen} />
      <Stack.Screen name="CasketUrnInputUrn" component={CasketUrnInputUrnScreen} />
      <Stack.Screen name="CasketUrnInputOther" component={CasketUrnInputOtherScreen} />
      <Stack.Screen name="CasketUrnData" component={CasketUrnDataScreen} />
      <Stack.Screen name="CasketUrnLockUnlock" component={CasketUrnLockUnlockScreen} />
      <Stack.Screen name="CasketUrnLocked" component={CasketUrnLockedScreen} />
      <Stack.Screen name="CasketUrnUnlocked" component={CasketUrnUnlockedScreen} />
      
      {/* Funeral Home Screens */}
      <Stack.Screen name="FuneralHomeIntro" component={FuneralHomeIntroScreen} />
      <Stack.Screen name="FuneralHomeInput" component={FuneralHomeInputScreen} />
      <Stack.Screen name="FuneralHomeData" component={FuneralHomeDataScreen} />
      <Stack.Screen name="FuneralHomeLockUnlock" component={FuneralHomeLockUnlockScreen} />
      <Stack.Screen name="FuneralHomeLocked" component={FuneralHomeLockedScreen} />
      <Stack.Screen name="FuneralHomeUnlocked" component={FuneralHomeUnlockedScreen} />

      {/* Funeral Instructions Screens */}
      <Stack.Screen name="FuneralInstructionsIntro" component={FuneralInstructionsIntroScreen} />
      <Stack.Screen name="FuneralInstructionsInput" component={FuneralInstructionsInputScreen} />
      <Stack.Screen name="FuneralInstructionsData" component={FuneralInstructionsDataScreen} />
      <Stack.Screen name="FuneralInstructionsLockUnlock" component={FuneralInstructionsLockUnlockScreen} />
      <Stack.Screen name="FuneralInstructionsLocked" component={FuneralInstructionsLockedScreen} />
      <Stack.Screen name="FuneralInstructionsUnlocked" component={FuneralInstructionsUnlockedScreen} />

      {/* Memorial Service Screens */}
      <Stack.Screen name="MemorialServiceIntro" component={MemorialServiceIntroScreen} />
      <Stack.Screen name="MemorialServiceInput" component={MemorialServiceInputScreen} />
      <Stack.Screen name="MemorialServiceData" component={MemorialServiceDataScreen} />
      <Stack.Screen name="MemorialServiceLockUnlock" component={MemorialServiceLockUnlockScreen} />
      <Stack.Screen name="MemorialServiceLocked" component={MemorialServiceLockedScreen} />
      <Stack.Screen name="MemorialServiceUnlocked" component={MemorialServiceUnlockedScreen} />

      {/* Letter To Loved Ones Screens */}
      <Stack.Screen name="LetterToLovedOnesIntro" component={LetterToLovedOnesIntroScreen} />
      <Stack.Screen name="LetterToLovedOnesInput" component={LetterToLovedOnesInputScreen} />
      <Stack.Screen name="LetterToLovedOnesData" component={LetterToLovedOnesDataScreen} />
      <Stack.Screen name="LetterToLovedOnesLockUnlock" component={LetterToLovedOnesLockUnlockScreen} />
      <Stack.Screen name="LetterToLovedOnesLocked" component={LetterToLovedOnesLockedScreen} />
      <Stack.Screen name="LetterToLovedOnesUnlocked" component={LetterToLovedOnesUnlockedScreen} />

      {/* Officiant Screens */}
      <Stack.Screen name="OfficiantIntro" component={OfficiantIntroScreen} />
      <Stack.Screen name="OfficiantInput" component={OfficiantInputScreen} />
      <Stack.Screen name="OfficiantData" component={OfficiantDataScreen} />
      <Stack.Screen name="OfficiantLockUnlock" component={OfficiantLockUnlockScreen} />
      <Stack.Screen name="OfficiantLocked" component={OfficiantLockedScreen} />
      <Stack.Screen name="OfficiantUnlocked" component={OfficiantUnlockedScreen} />

      {/* Prayers and Readings Screens */}
      <Stack.Screen name="PrayersReadingsIntro" component={PrayersReadingsIntroScreen} />
      <Stack.Screen name="PrayersReadingsInput" component={PrayersReadingsInputScreen} />
      <Stack.Screen name="PrayersReadingsData" component={PrayersReadingsDataScreen} />
      <Stack.Screen name="PrayersReadingsLockUnlock" component={PrayersReadingsLockUnlockScreen} />
      <Stack.Screen name="PrayersReadingsLocked" component={PrayersReadingsLockedScreen} />
      <Stack.Screen name="PrayersReadingsUnlocked" component={PrayersReadingsUnlockedScreen} />

      {/* Tribute Donations Screens */}
      <Stack.Screen name="TributeDonationsIntro" component={TributeDonationsIntroScreen} />
      <Stack.Screen name="TributeDonationsInput" component={TributeDonationsInputScreen} />
      <Stack.Screen name="TributeDonationsData" component={TributeDonationsDataScreen} />
      <Stack.Screen name="TributeDonationsLockUnlock" component={TributeDonationsLockUnlockScreen} />
      <Stack.Screen name="TributeDonationsLocked" component={TributeDonationsLockedScreen} />
      <Stack.Screen name="TributeDonationsUnlocked" component={TributeDonationsUnlockedScreen} />

      {/* Food Preferences Screens */}
      <Stack.Screen name="FoodPreferencesIntro" component={FoodPreferencesIntroScreen} />
      <Stack.Screen name="FoodPreferencesInput" component={FoodPreferencesInputScreen} />
      <Stack.Screen name="FoodPreferencesData" component={FoodPreferencesDataScreen} />
      <Stack.Screen name="FoodPreferencesLockUnlock" component={FoodPreferencesLockUnlockScreen} />
      <Stack.Screen name="FoodPreferencesLocked" component={FoodPreferencesLockedScreen} />
      <Stack.Screen name="FoodPreferencesUnlocked" component={FoodPreferencesUnlockedScreen} />

      {/* Music Screens */}
      <Stack.Screen name="MusicIntro" component={MusicIntroScreen} />
      <Stack.Screen name="MusicInput" component={MusicInputScreen} />
      <Stack.Screen name="MusicData" component={MusicDataScreen} />
      <Stack.Screen name="MusicLockUnlock" component={MusicLockUnlockScreen} />
      <Stack.Screen name="MusicLocked" component={MusicLockedScreen} />
      <Stack.Screen name="MusicUnlocked" component={MusicUnlockedScreen} />

      {/* PallBearer Screens */}
      <Stack.Screen name="PallBearerIntro" component={PallBearerIntroScreen} />
      <Stack.Screen name="PallBearerInput" component={PallBearerInputScreen} />
      <Stack.Screen name="PallBearerData" component={PallBearerDataScreen} />
      <Stack.Screen name="PallBearerLockUnlock" component={PallBearerLockUnlockScreen} />
      <Stack.Screen name="PallBearerLocked" component={PallBearerLockedScreen} />
      <Stack.Screen name="PallBearerUnlocked" component={PallBearerUnlockedScreen} />

      {/* TraditionsRituals Screens */}
      <Stack.Screen name="TraditionsRitualsIntro" component={TraditionsRitualsIntroScreen} />
      <Stack.Screen name="TraditionsRitualsInput" component={TraditionsRitualsInputScreen} />
      <Stack.Screen name="TraditionsRitualsData" component={TraditionsRitualsDataScreen} />
      <Stack.Screen name="TraditionsRitualsLockUnlock" component={TraditionsRitualsLockUnlockScreen} />
      <Stack.Screen name="TraditionsRitualsLocked" component={TraditionsRitualsLockedScreen} />
      <Stack.Screen name="TraditionsRitualsUnlocked" component={TraditionsRitualsUnlockedScreen} />

      {/* WakeDetails Screens */}
      <Stack.Screen name="WakeDetailsIntro" component={WakeDetailsIntroScreen} />
      <Stack.Screen name="WakeDetailsInput" component={WakeDetailsInputScreen} />
      <Stack.Screen name="WakeDetailsData" component={WakeDetailsDataScreen} />
      <Stack.Screen name="WakeDetailsLockUnlock" component={WakeDetailsLockUnlockScreen} />
      <Stack.Screen name="WakeDetailsLocked" component={WakeDetailsLockedScreen} />
      <Stack.Screen name="WakeDetailsUnlocked" component={WakeDetailsUnlockedScreen} />

      {/* Eulogy Screens */}
      <Stack.Screen name="EulogyIntro" component={EulogyIntroScreen} />
      <Stack.Screen name="EulogyIntro2" component={EulogyIntro2Screen} />
      <Stack.Screen name="EulogyInput" component={EulogyInputScreen} />
      <Stack.Screen name="EulogyWriterInput" component={EulogyWriterInputScreen} />
      <Stack.Screen name="EulogyData" component={EulogyDataScreen} />
      <Stack.Screen name="EulogyLockUnlock" component={EulogyLockUnlockScreen} />
      <Stack.Screen name="EulogyLocked" component={EulogyLockedScreen} />
      <Stack.Screen name="EulogyUnlocked" component={EulogyUnlockedScreen} />

      {/* HeadstoneDetails Screens */}
      <Stack.Screen name="HeadstoneDetailsIntro" component={HeadstoneDetailsIntroScreen} />
      <Stack.Screen name="HeadstoneDetailsInput" component={HeadstoneDetailsInputScreen} />
      <Stack.Screen name="HeadstoneDetailsData" component={HeadstoneDetailsDataScreen} />
      <Stack.Screen name="HeadstoneDetailsLockUnlock" component={HeadstoneDetailsLockUnlockScreen} />
      <Stack.Screen name="HeadstoneDetailsLocked" component={HeadstoneDetailsLockedScreen} />
      <Stack.Screen name="HeadstoneDetailsUnlocked" component={HeadstoneDetailsUnlockedScreen} />

      {/* ObituaryDetails Screens */}
      <Stack.Screen name="ObituaryDetailsIntro" component={ObituaryDetailsIntroScreen} />
      <Stack.Screen name="ObituaryDetailsInput" component={ObituaryDetailsInputScreen} />
      <Stack.Screen name="ObituaryDetailsWriterInput" component={ObituaryDetailsWriterInputScreen} />
      <Stack.Screen name="ObituaryDetailsData" component={ObituaryDetailsDataScreen} />
      <Stack.Screen name="ObituaryDetailsLockUnlock" component={ObituaryDetailsLockUnlockScreen} />
      <Stack.Screen name="ObituaryDetailsLocked" component={ObituaryDetailsLockedScreen} />
      <Stack.Screen name="ObituaryDetailsUnlocked" component={ObituaryDetailsUnlockedScreen} />
    </Stack.Navigator>
  );
};

export default WishesStackNavigator;